<template>
  <router-view/>
</template>

<script>

// export default{
//   data(){
//     return{
//       //
//     }
//   },
//   methods: {
//     callFunction(){
//       alert('hi');
//     }
//   },
//   mounted(){
//     this.callFunction();
//   }
// }
</script>

